import { env } from '~publish/env'

export const makeCallbackUrl = (path: string): string => {
  return `${env.VITE_CALLBACK_URL}${path}`
}

type OAuthInitializeCallbackUrlParams = {
  service: string
  state: string
  redirectUri: string
}
export const makeOAuthInitializeCallbackUrl = ({
  service,
  state,
  redirectUri,
}: OAuthInitializeCallbackUrlParams): string => {
  return makeCallbackUrl(
    `/auth/oauth/${service}/authorize?state=${encodeURIComponent(
      state,
    )}&redirect_uri=${encodeURIComponent(redirectUri)}`,
  )
}

type CanvaDesignOpenCallbackUrlParams = {
  designId: string
  width?: number | string
  height?: number | string
  title?: string
  sessionId?: string
  mediaFetchUrl?: string
}
export const makeCanvaDesignOpenCallbackUrl = ({
  designId,
  width,
  height,
  title,
  sessionId,
  mediaFetchUrl,
}: CanvaDesignOpenCallbackUrlParams): string => {
  const searchParams = new URLSearchParams()
  searchParams.set('designId', designId)
  if (width) {
    searchParams.set('width', width.toString())
  }
  if (height) {
    searchParams.set('height', height.toString())
  }
  if (title) {
    searchParams.set('title', title)
  }
  if (sessionId) {
    searchParams.set('state', sessionId)
  }
  if (mediaFetchUrl) {
    searchParams.set('media_fetch_url_hint', mediaFetchUrl)
  }
  searchParams.set('return_url', window.location.href)
  return makeCallbackUrl(
    `/integrations/canva/design/open?${searchParams.toString()}`,
  )
}
